/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from 'react'
import styles from "./BrandDetails.module.css"
import { useParams } from 'react-router-dom'
import axios from 'axios';
export default function () {
    let [brandDetails,setBrandDetails] = useState(null);
    let {id} = useParams();
    async function getBrandDetails(brand_id) {
        let {data} = await axios.get(`https://ecommerce.routemisr.com/api/v1/brands/${brand_id}`);
        setBrandDetails(data.data)
    }
    useEffect(() => {
        if(id){
            getBrandDetails(id);
        }
    },[])
    return (
        <>
    {brandDetails ? (
        <div className="container my-5">
        <div className="row justify-content-center">
            <div className="col-md-6 text-center shadow p-4 rounded bg-light">
            <div className="mb-3">
                <img
                src={brandDetails.image}
                alt={brandDetails.slug}
                className="img-fluid rounded w-50"
                />
            </div>
            <h3 className="fw-bold text-main">{brandDetails.name}</h3>
            <p className="text-muted">
                <strong>Created At:</strong>{" "}
                {new Date(brandDetails.createdAt).toLocaleDateString()}
            </p>
            <p className="text-muted">
                <strong>Updated At:</strong>{" "}
                {new Date(brandDetails.updatedAt).toLocaleDateString()}
            </p>
            </div>
        </div>
        </div>
    ) : (
        <div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div>
    )}
</>

    )
}
